(function () {
  var header = document.querySelector('[data-site-header]');
  if (!header) return;

  function isDesktopPointer() {
    return window.matchMedia('(pointer: fine)').matches;
  }

  function enforceDesktopNav() {
    if (isDesktopPointer() && header.classList.contains('site-header--compress')) {
      header.classList.remove('site-header--compress');
    }
  }

  enforceDesktopNav();

  new MutationObserver(enforceDesktopNav).observe(header, {
    attributes: true,
    attributeFilter: ['class']
  });

  window.addEventListener('resize', enforceDesktopNav);
})();
